/* eslint-disable react/jsx-no-bind */
import * as yup from "yup";
import { Alert, Button, Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Formik } from "formik";
import { useMutation } from "react-query";
import yupPassword from "yup-password";

import PasswordStrengthCard from "./registration/PasswordStrengthCard";
import { resetPasswordFn } from "../../services/wp.auth.service";

yupPassword(yup);

const schema = yup.object().shape({
	confirm: yup.string().oneOf([yup.ref("password"), null], "Password must match").
		required(),
	password: yup.string().password().
		required()
});

const ResetPassword = () => {
	const navigate = useNavigate();
	const [newPassword, setNewPassword] = useState("");
	const [searchParams] = useSearchParams();
	const login = searchParams.get("login");
	const key = searchParams.get("key");

	useEffect(() => {
		if (!login || !key) {
			navigate("/login");
		}
	}, []);

	const {
		error,
		isError,
		isLoading,
		mutate
	} = resetPasswordFn(useMutation);
	const onSubmit = useCallback(({ password }) => {
		mutate({
			key,
			login,
			password
		}, {
			onSuccess: () => {
				const message = "Password changed successfully. Please log in.";
				navigate("/login", { state: { message } });
			}
		});
	});

	return (
		<Formik
			initialValues={{
				confirm: "",
				password: ""
			}}
			onSubmit={onSubmit}
			validationSchema={schema}
		>
			{({
				errors,
				handleSubmit,
				handleChange,
				values
			}) => (
				<Form as={Row} noValidate onSubmit={handleSubmit}>
					<Col md={6} sm={12}>
						<FloatingLabel className="mb-4" controlId="newPassword" label="Choose New Password">
							<Form.Control
								isInvalid={Boolean(errors.password)}
								name="password"
								onChange={(evt) => {
									handleChange(evt);
									setNewPassword(evt.target.value);
								}}
								placeholder="Choose New Password"
								required
								type="password"
								value={values.password}
							/>

							<Form.Control.Feedback type="invalid">
								{errors.password}
							</Form.Control.Feedback>
						</FloatingLabel>

						<FloatingLabel className="mb-4" controlId="newPasswordConfirm" label="Confirm New Password">
							<Form.Control
								isInvalid={Boolean(errors.confirm)}
								name="confirm"
								onChange={handleChange}
								placeholder="Confirm New Password"
								required
								type="password"
								value={values.confirm}
							/>

							<Form.Control.Feedback type="invalid">
								{errors.confirm}
							</Form.Control.Feedback>
						</FloatingLabel>

						{isError ? <Alert variant="danger">{error.message}</Alert> : null}

						<Button disabled={isLoading} onClick={handleSubmit} type="submit" variant="primary">
							{isLoading ? <Spinner animation="border" size="sm" /> : "Reset and Login"}
						</Button>
					</Col>
					<Col md={6} sm={12}>
						<PasswordStrengthCard password={newPassword} />
					</Col>
				</Form>
			)}
		</Formik>
	);
};

export default ResetPassword;
